import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { KfmProcessType } from '@shared/enums/process-type.enum';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { HsLayerModule } from '@hsetu/ngui-resources';
import { HsButtonModule, HsDividerModule } from '@hsetu/ngui-components';
import {
  CANCEL_LABEL,
  CHOOSE_SALES_TYPE_LABEL,
  INVOICE_LABEL,
  OFFER_LABEL,
  TASK_LABEL,
  YES_LABEL,
} from '@modules/sales/i18n/label-text-constants';

@Component({
  selector: 'kfm-sales-selection-dialog',
  imports: [
    CommonModule,
    FormsModule,
    HsLayerModule,
    HsDividerModule,
    HsButtonModule,
  ],
  templateUrl: './kfm-sales-selection-dialog.component.html',
})
export class KfmSalesSelectionDialogComponent {
  private readonly _data = inject<{ processType: KfmProcessType }>(DIALOG_DATA);

  protected readonly dialogRef = inject<DialogRef<KfmProcessType>>(
    DialogRef<KfmProcessType>,
  );

  protected readonly dialogTitle = CHOOSE_SALES_TYPE_LABEL;
  protected readonly taskLabel = TASK_LABEL;
  protected readonly invoiceLabel = INVOICE_LABEL;
  protected readonly offerLabel = OFFER_LABEL;
  protected readonly cancelLabel = CANCEL_LABEL;
  protected readonly yesLabel = YES_LABEL;

  public KfmProcessType = KfmProcessType;

  protected selectedProcessType = KfmProcessType.Order;

  constructor() {
    if (this._data?.processType) {
      if (this._data.processType === KfmProcessType.Offer)
        this.selectedProcessType = KfmProcessType.Order;
      else if (
        this._data.processType === KfmProcessType.Order ||
        this._data.processType === KfmProcessType.Invoice
      )
        this.selectedProcessType = KfmProcessType.Invoice;
      else this.selectedProcessType = KfmProcessType.Order;
    }
  }
}
